import React, { useState } from "react";
import { Formik } from "formik";
import queryString from "query-string";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormHelperText, useMediaQuery } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import PinInputCustom from "../../components/PinInputCustom";
import { useAlert } from "../../context/AlertContext";
import { forgotPasswordCode } from "../../crud/auth.crud";
import * as auth from "../../store/ducks/auth.duck";
import styles from "../../../styles/Login.module.css";

const CodigoSenha = (props) => {
    const { email } = queryString.parse(props.location.search, { decode: false });

    const [submitting, setSubmitting] = useState(false);
    const history = useHistory();
    const isMobileScreen = useMediaQuery("(max-width: 576px)");

    const { showAlert } = useAlert();

    const onSubmit = (values) => {
        setSubmitting(true);

        forgotPasswordCode({ email, code: values.pin })
            .then((res) => history.push(`/alterar-senha?email=${email}&token=${res.data.token}`))
            .catch((err) => {
                showAlert({
                    icon: "error",
                    title: "Ops!",
                    text: Array.isArray(err?.response?.data?.errors) ? err?.response?.data?.errors[0] : "Parece que houve um problema. Por favor, entre em contato com o suporte.",
                    textStyle: { textAlign: 'center' },
                    confirmButton: true,
                    confirmText: "Ok",
                });
            }).finally(() => setSubmitting(false));
    };

    const getInitialValues = () => {
        return {
            pin: "",
        };
    };

    const validate = (values) => {
        const errors = {};

        if (!values.pin) {
            errors.pin = "O código de recuperação é obrigatório.";
        } else if (values.pin.length < 6) {
            errors.pin = "O código de recuperação deve possuir 6 dígitos.";
        }

        return errors;
    };

    return (
        <div className={styles.authContainer}>
            <div className={styles.loginContainer}>
                <div className={styles.loginLeft}>
                    <img src={"/images/logo.png"} alt="Suria Logo" className={styles.logoImg} />

                    <div className={styles.containerFormCadastro}>
                        <button type="button" className={styles.buttonBack} onClick={() => history.push("/esqueceu-senha")}>
                            <ArrowBackIosIcon />

                            <p>Código de recuperação</p>
                        </button>

                        <p className={styles.textoPrimeiroAcesso}>Insira abaixo o código de recuperação recebido no seu e-mail.</p>

                        <Formik initialValues={getInitialValues()} validate={validate} onSubmit={onSubmit}>
                            {({ touched, errors, handleSubmit, setFieldValue }) => (
                                <form noValidate onSubmit={handleSubmit} className={styles.formLoginContainer}>
                                    <div>
                                        <div className={styles.inputPinContainer}>
                                            <PinInputCustom length={6} onChange={(v) => setFieldValue("pin", v)} onComplete={(v) => setFieldValue("pin", v)} isMobile={isMobileScreen} />
                                        </div>
                                        {touched.pin && errors.pin && <FormHelperText style={{ color: '#fd397a', textAlign: 'center' }}>{errors.pin}</FormHelperText>}
                                    </div>
                                    <div className={`${styles.buttonContainer} ${styles.paddingButton}`}>
                                        <button type="submit" className={styles.buttonLogin} disabled={submitting}>
                                            {!submitting ? "Recuperar senha" : <div className="icon-loading" />}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                </div>

                <div className={styles.loginRight}>
                    <div className={styles.imagemLateralLogin} style={{ backgroundImage: "url(/images/lateral-login.png)" }} />
                </div>
            </div>
        </div>
    );
};

export default connect(null, auth.actions)(CodigoSenha);
